import React from 'react';

const CategoryPage = ()=>{
    return (
        <div>CategoryPage</div>
    )
}

export default CategoryPage;
